import { defineComponent as _defineComponent } from 'vue'
import MainNavigation from './chrome/MainNavigation.vue';
import Toaster from './shared/Toaster.vue';
import LoadingOverlay from './shared/LoadingOverlay.vue';
import NewsletterPopup from './shared/NewsletterPopup.vue';
import NewsletterModal from './shared/NewsletterModal.vue';
import CommunicationModal from './views/communication-modal/CommunicationModal.vue';
import SignUpDiscountPopup from './shared/SignUpDiscountPopup.vue';
import PageFooter from './chrome/PageFooter.vue';
import BreadcrumbItem from './chrome/BreadcrumbItem.vue';
import BodyPadding from './chrome/BodyPadding.vue';
import ServerView from './spa/ServerView.vue';
import SpaServer from './spa/SpaServer.vue';
import BreakpointService from '@/core/responsive/breakpoints/breakpoint.service';
import { StorageService } from '@/core';
import DualLanguagePrompt from '@/ui/chrome/DualLanguagePrompt.vue';

import DomService from '../core/dom.service';
import { store } from '../store';
import { Key } from '@/core/keycodes';
import TopBarNavigation from '@/ui/chrome/TopBarNavigation.vue';
import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '../../tailwind.config.js';
import { computed, onUnmounted, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router/composables';
import VueRouter, { Route } from 'vue-router';
import { useImpersonation } from '@/store/impersonation.composable';
import useBreakpoints from '@/core/responsive/breakpoints/breakpoint.mixin';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const basketUrl = computed<string>(() => store.getters['app/basketUrl']);
const quoteBasketUrl = computed<string>(() => store.getters['app/quoteBasketUrl']);
const hasModeChanged = computed<ModeChangeFunction>(() => store.getters['app/hasModeChanged']);
const isBasketVisible = computed<boolean>(() => store.getters['app/isBasketVisible']);
const isQuoteBasketVisible = computed<boolean>(() => store.getters['app/isQuoteBasketVisible']);
const showNewsletterPopup = computed<boolean>(() => store.getters['app/showNewsletterPopup']);
const showSignUpDiscountPopup = computed<boolean>(() => store.getters['app/showSignUpDiscountPopup']);
const theme = computed<ColorTheme>(() => store.getters['app/theme']);
const breakpointIsActive = useBreakpoints();

function initialize() {
    store.dispatch('app/initialize');
}

const basket = computed<IBasketViewModel>(() => store.getters['basket/basket']);

function fetchBasket() {
    store.dispatch('basket/fetchBasket');
}
function fetchQuoteBasket() {
    store.dispatch('quotebasket/fetchQuoteBasket');
}

const { impersonation, isActiveSalesConsultant } = useImpersonation();
const showContent = computed<boolean>(() => !impersonation.value || isActiveSalesConsultant.value);

// contains the currently open modals close function
const closeModal = ref<() => void>();

const activeBreakpoint = computed<string>(() => {
    return BreakpointService.getActiveBreakpoint();
});
const debugGrid = computed<boolean>(() => {
    try {
        return !!localStorage.getItem('debugGrid');
    } catch (e) {
        return false;
    }
});

initialize();

const route = useRoute();
const router = useRouter();
if (shouldFetchBasket(route, router)) {
    fetchBasket();
}
if (shouldFetchQuoteBasket(route, router)) {
    fetchQuoteBasket();
}

document.addEventListener('keydown', closeModalOnEsc);

onUnmounted(() => {
    document.removeEventListener('keydown', closeModalOnEsc);
});

function closeModalOnEsc(event: KeyboardEvent): void {
    if (event.keyCode === Key.ESC && closeModal.value) {
        closeModal.value();
    }
}

function onModalUpdate({ passengers: modalVnode }): void {
    try {
        closeModal.value = modalVnode[0].context.close;
        // console.log('added close modal function');
    } catch (err) {
        closeModal.value = null;
        // console.log('removed close modal function', err);
    }
}

function onModalOpen(): void {
    DomService.addElementClass('html', 'modal-open');
}

function onModalClose(): void {
    DomService.removeElementClass('html', 'modal-open');
}

watch(basket, onBasketChanged);

function onBasketChanged(basket: IBasketViewModel): void {
    StorageService.setItemAs<IBasketViewModel>('basket', basket);
}

function shouldFetchBasket(route: Route, router: VueRouter): boolean {
    return route.path !== basketUrl.value && isBasketVisible.value && !hasModeChanged.value(router.currentRoute.path);
}

function shouldFetchQuoteBasket(route: Route, router: VueRouter): boolean {
    return route.path !== quoteBasketUrl.value && isQuoteBasketVisible.value && !hasModeChanged.value(router.currentRoute.path);
}

const themeStyleContent = computed<string>(() => {
    const themeValue : any = { 'background-color': theme.value.pageBackgroundColor, color: theme.value.textColor };
    const nonEmptyValues = Object.keys(themeValue).filter(k => themeValue[k]);
    const backgroundColor = nonEmptyValues.length
        ? `.page-custom-background-color {${nonEmptyValues.map(k => `${k}:${themeValue[k]}`).join('; ')}}`
        : '';
    let customBorderAndTextColors = '';
    let formElements = '';
    if (theme.value.textColor) {
        const fullConfig = resolveConfig(tailwindConfig);
        const alpha = { 25: '40', 60: '99', 100: '' };
        customBorderAndTextColors = Object.keys(alpha).map(x => `
                .custom-border-${x} { border-color: ${theme.value.textColor}${alpha[x]}; } 
                .custom-text-${x} { color: ${theme.value.textColor}${alpha[x]}; }
                @media (min-width: ${fullConfig.theme.screens.md}) { .md\\:custom-text-${x} { color: ${theme.value.textColor}${alpha[x]}; } }
            `).join(' ');
        formElements = `input:hover, textarea:hover, input:focus, textarea:focus { border-color: ${theme.value.textColor}; }`;
    }
    return backgroundColor + customBorderAndTextColors + formElements;
});


return { __sfc: true,basketUrl, quoteBasketUrl, hasModeChanged, isBasketVisible, isQuoteBasketVisible, showNewsletterPopup, showSignUpDiscountPopup, theme, breakpointIsActive, initialize, basket, fetchBasket, fetchQuoteBasket, impersonation, isActiveSalesConsultant, showContent, closeModal, activeBreakpoint, debugGrid, route, router, closeModalOnEsc, onModalUpdate, onModalOpen, onModalClose, onBasketChanged, shouldFetchBasket, shouldFetchQuoteBasket, themeStyleContent, MainNavigation, Toaster, LoadingOverlay, NewsletterPopup, NewsletterModal, CommunicationModal, SignUpDiscountPopup, PageFooter, BreadcrumbItem, BodyPadding, ServerView, SpaServer, DualLanguagePrompt, TopBarNavigation }
}

})